import type { AddonManagementEnrichFormRequest } from 'models/forms/AddonManagementEnrichFormRequest';
import type { AddonManagementFormResult } from 'models/forms/AddonManagementFormResult';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { toStartOfDay } from 'utils/core/date';
import type { IHttpClient } from 'utils/http/httpClient.model';

export interface AddonFormsRequest {
  clientBdrId?: string;
  issueDateOnAndAfter?: string;
  productType?: string;
}
export interface InitFormsResponse {
  forms: AddonManagementFormResult[];
  isTradesFetchSuccessful: boolean;
}
export function addonManagementApiConnector(http$: IHttpClient) {
  const addonManagementFormApi = 'api/v1/addon-management';
  return {
    initForms(request: AddonFormsRequest): Observable<InitFormsResponse> {
      return http$
        .getJSON<InitFormsResponse>({
          url: `${addonManagementFormApi}/forms`,
          params: { ...request, issueDateOnAndAfter: toISOString(request.issueDateOnAndAfter) },
        })
        .pipe(map(r => r.payload));
    },
    enrichForm(request: AddonManagementEnrichFormRequest): Observable<AddonManagementFormResult> {
      return http$
        .postJSON<AddonManagementFormResult>({ url: `${addonManagementFormApi}/modify`, body: request })
        .pipe(map(({ payload }) => payload));
    },
  };
}

function toISOString(date?: string) {
  return date ? toStartOfDay(new Date(date)).toISOString() : undefined;
}
